document.addEventListener('DOMContentLoaded', () => {
  const subject = document.getElementById('BrioContactSubject');
  document.querySelectorAll('[data-contact-subject]').forEach((link) => {
    link.addEventListener('click', () => {
      if (!subject) return;
      subject.value = link.getAttribute('data-contact-subject') || '';
      window.setTimeout(() => subject.focus({ preventScroll: true }), 350);
    });
  });

  const revealItems = document.querySelectorAll('[data-contact-reveal]');
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px', threshold: 0 });
  document.body.classList.add('js-ready');
  revealItems.forEach((item) => observer.observe(item));
});